import { assertNotEmpty } from '@festina-life/core'
import { type FormikProps, FormikTextInput } from '@festina-life/ui/formikForms'
import { useTranslate } from '@festina-life/ui/hooks'

import type { BranchCreationInput } from '../types'
import { validate } from './helpers'

type Props = {
  state: FormikProps<BranchCreationInput>
}

export const NamingStep = ({ state: { values } }: Props) => {
  const translate = useTranslate()

  assertNotEmpty(values.server)

  return (
    <>
      <p>
        {translate('branchCreationWizard.namingStep.description', {
          server: values.server,
        })}
      </p>
      <FormikTextInput
        isRequired
        name={validate('branchName')}
        label={translate('branchCreationForm.branchName.label')}
      />
    </>
  )
}
